import { render, staticRenderFns } from "./ArticleTile.vue?vue&type=template&id=efd4d654&scoped=true"
import script from "./ArticleTile.vue?vue&type=script&lang=js"
export * from "./ArticleTile.vue?vue&type=script&lang=js"
import style0 from "./ArticleTile.vue?vue&type=style&index=0&id=efd4d654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd4d654",
  null
  
)

export default component.exports